import { useEffect } from "react";
import { useJwt } from "../../contexts/jwtContext";
import { Navigate, useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";

// If user is not authenticated, navigate back to login page
// Else, shows page normally
const RouteProtection = () => {
  const { jwt } = useJwt();
  const navigate = useNavigate();
  const toast = useToast();

  const checkJwtExpiration = () => {
    const localJwt = window.sessionStorage.getItem("jwt");
    // cleared by fetchWithToken function
    if (!localJwt) {
      toast({
        title: "您的登入已過期，請重新登入",
        status: "info",
        isClosable: true,
      });

      navigate("/");
    }
  };

  // listen to sessionStorage, in case it's cleared by fetchWithToken
  useEffect(() => {
    window.addEventListener("storage", checkJwtExpiration);

    return () => {
      window.removeEventListener("storage", checkJwtExpiration);
    };
  }, []);

  if (jwt === undefined || jwt === "") {
    // to login page
    return <Navigate to="/" />;
  } else {
    return <></>;
  }
};

export default RouteProtection;
